/**
 * ai-assistant FeatureModule — the AI OPERATIONAL helpdesk surface (deployClass HYBRID: mounts on a
 * local install; the local retrieval + instructions.md stay readable, the LLM/embedding are
 * agent-proxied). Two screens under /assistant/*:
 *
 *   /assistant                — the conversational helpdesk (sessions, cited chunk titres, the
 *                               disclaimer, the abstenu / disabled / error governance states).
 *   /assistant/instructions   — the lab-Admin instructions.md editor (append-only versioned).
 *
 * Gating model. Both screens need the read cap (ai.assistant.query); the instructions PUBLISH needs
 * ai.assistant.instructions.manage (lab-Admin). So the MODULE gate is ai.assistant.query (any staff
 * may reach the helpdesk), and the instructions screen renders a read-only editor + disables the
 * publish action when the manage cap is absent (the server re-checks every request — useCan only
 * hides/disables UI, never the trust boundary).
 *
 * Cloud-only contract: although the router IS mounted locally, when an endpoint 404s (the module is
 * genuinely un-mounted on an install) the screens render a clean "indisponible sur cette installation"
 * state rather than a hard error. The conversation path additionally degrades gracefully INTERNALLY:
 * a {status:'disabled'} answer (no AI key) renders a polite notice, never blocking the operator.
 *
 * To register: add `import aiAssistantModule from "@/features/ai-assistant";` + `aiAssistantModule` to
 * the MODULES array in src/app/registry.ts (the ONLY router-side edit a feature requires).
 */
import type { FeatureModule } from "@/app";
import { AI_CAPS, MODULE_CAPS } from "./caps";
import { registerAiAssistantMessages } from "./messages";
import { AssistantPage } from "./screens/AssistantPage";
import { InstructionsPage } from "./screens/InstructionsPage";

const aiAssistantModule: FeatureModule = {
  id: "ai-assistant",
  title: "Assistant opérationnel",
  // Module gate: the minimum capability to reach any ai-assistant screen (server cap key).
  requiredCapabilities: MODULE_CAPS,
  routes: [
    { path: "/assistant", element: <AssistantPage /> },
    { path: "/assistant/instructions", element: <InstructionsPage /> },
  ],
  nav: [
    {
      id: "ai-assistant",
      path: "/assistant",
      label: "nav.ai.assistant",
      icon: "✦",
      order: 90,
      section: "nav.section.assist",
    },
    {
      id: "ai-instructions",
      path: "/assistant/instructions",
      label: "nav.ai.instructions",
      icon: "≣",
      order: 91,
      section: "nav.section.assist",
      // Surface the editor entry to the read cap; publishing is gated in-screen on the manage cap.
      requiredCapabilities: [AI_CAPS.query],
    },
  ],
  onRegister() {
    registerAiAssistantMessages();
  },
};

export default aiAssistantModule;
